var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',[_c('b-icon',{staticClass:"pdf-icon",attrs:{"icon":"arrow-up-right-square"}}),_c('a',{staticClass:"pdf-link",attrs:{"href":_vm.downloadLink,"target":"_blank"}},[_vm._v(_vm._s(_vm.fileNameWithoutExtension)+" als PDF")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }